import {_utils, viewportChecker} from "../utils/_utils.js";
import {_state} from "../state/state.js";

export const contactFormsSend = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.contact-form-section-js', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section) => {
    const formWrapper = section.querySelector('.contact-form-content-js')
    const form = formWrapper?.querySelector('form');
    const thanksPop = section.querySelector('.contact-form-thanks-js')
    const thanksPopClose = section.querySelector('.contact-form-thanks-close-js')
    const redirectPage = section.getAttribute('data-redirect-page')

    form?.addEventListener('wpcf7mailsent', () => {
        if (redirectPage !== null) {
            window.location.href = redirectPage;
        } else {
            thanksPop?.classList.add('show');
            formWrapper?.classList.add('hide');

            if (section.classList.contains('contact-us')) {
                document.documentElement.classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
            }

            //scroll to top block

            const headerHeight = document.querySelector('.header').getBoundingClientRect().height
            const scrollBlock = form.closest('section')
            const elementOffset = (scrollBlock?.getBoundingClientRect().top + window.scrollY) - headerHeight
            // smoothScrollTo(elementOffset,2)
            window.scrollTo({
                top: elementOffset,
                behavior: "smooth",
            });
        }
    })

    thanksPopClose?.addEventListener('click', () => {
        thanksPop?.classList.remove('show');
        formWrapper?.classList.remove('hide');
        if (section.classList.contains('contact-us')) {
            document.documentElement.classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
        }
    })

    //disabled button when form submitting

    form?.addEventListener('submit', function(event) {
        const button = form.querySelector('button.wpcf7-submit');
        button.disabled = true;
        //button.value = "Sending...";
    });

    document.addEventListener('wpcf7submit', function(event) {
        var buttons = document.querySelectorAll('.wpcf7-submit[disabled]');
        buttons.forEach(function(button) {
            button.disabled = false;
            //button.value = "Send message";
        });
    });
}
